import { render, staticRenderFns } from "./AppUpdate.vue?vue&type=template&id=ff24799c"
import script from "./AppUpdate.vue?vue&type=script&lang=js"
export * from "./AppUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports